//Form Validation for chef email selection for delegation
const Validator = require("validator");
const isEmpty = require("../../common/functions/is-empty");

export function validateChefEmailInput(data, executiveChefList) {
  let validationErrors = {};
  //   const { executiveChefList = [] } = useFormDropdownFields();

  data = !isEmpty(data) ? data : "";
  if (Validator.isEmpty(data)) {
    validationErrors.chefEmail = "Chef Email Is Required";
  }

  // checks if email is email
  if (!Validator.isEmail(data)) {
    validationErrors.chefEmail = "Email is invalid";
  }

  if (executiveChefList.some((object) => object.email === data)) {
    validationErrors.chefEmail =
      "Chef email cannot be an Executive Chef's email";
  }
  return {
    validationErrors,
    isValid: isEmpty(validationErrors),
  };
}
